import { render, staticRenderFns } from "./zyzytj.vue?vue&type=template&id=1b1cea9a&scoped=true"
import script from "./zyzytj.vue?vue&type=script&lang=js"
export * from "./zyzytj.vue?vue&type=script&lang=js"
import style0 from "./zyzytj.vue?vue&type=style&index=0&id=1b1cea9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1cea9a",
  null
  
)

export default component.exports